'use strict';
angular.module('cloudxcmClientsApp')
    .config(['$routeProvider', function ($routeProvider) {
        $routeProvider
            .when('/pages/not_registered', {
                templateUrl: 'app/pages/user_not_registered/page.html',
                controller: 'userNotRegistered as vm'
            });
    }]);
